import React from 'react';
import loginStyles from '../../../stylesheets/components/login.module.scss';

const LoginFooter = () => {
  return (
    <div className={loginStyles.loginFooter}>
      <p className={loginStyles.loginLegalCopy}>
        By continuing, you agree to the{' '}
        <a
          className={loginStyles.loginInlineLink}
          href="https://www.propertymatrix.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </a>{' '}
        and{' '}
        <a
          className={loginStyles.loginInlineLink}
          href="https://www.propertymatrix.com/policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        .
      </p>
    </div>
  );
};

export default LoginFooter;
